export const products = [
    {
        id: 1,
        name: '环形交叉带分拣机',
        src: require("@/assets/img/Circularintersectionbelt.webp"),
        describe: [
            '环形交叉带分拣机，是目前最主流的快递自动化分拣设备类型，主要由供件系统、分拣小车、下件系统及控制系统四个部分组成。在控制系统的协调控制下实现包裹从供件系统导入分拣小车进行分拣，由下件系统完成包裹物理位置的分类存放，从而达到包裹分拣成功。',
            '目前广泛应用的线体类型有三种， 分别是单层单车分拣系统、双层单车分拣系统、单层双车分拣系统。 对于场地面积不足但分拣需求量大 的网点，亦可定制三层、四层的立体分拣统，确保网点的高效运转。'
        ],
        advantage: [
            '分拣效率高(单层单车效率可达3万票/小时，双车或者双层可以成倍提高效率)；',
            '格口数量多；',
            '错分率低 < 0.01%；',
            '特别适合出港小件集包。'
        ],
        scene: '场地空间大，件量大，对分拣效率要求很高的大中型分拣中心或电商中心。',
        img: require("@/assets/img/Technicalparametersroundabout.png"),
        Image: require("@/assets/img/Circularbenefits.png"),
        photos: [
            require("@/assets/img/circular1.png"),
            require("@/assets/img/circular2.png"),
        ]
    },
    {
        id: 2,
        name: '直线式交叉带分拣机',
        src: require("@/assets/img/Linearintersectionzone.png"),
        describe: [
            '末端中小网点首选设备；',
            '成本低/占地小/工期短；',
            '直线交叉带分拣系统是专为中小网点研发的分拣设备，其应用范围广、占地面积小、高效低耗、高性价比。供件时只需将快递面单朝上，放入规定的区域内，配合供件系统实现分拣主机高效、准确的处理，亦可接入卸货伸缩机实现自动上件。'
        ],
        advantage: [
            '分拣效率较高(单机理论效率1万票/小时)；',
            '可将包裹直接运至出库格口，省略集包和搬运过程；',
            '错分率低 < 0.01%；',
            '特别适合进港件分拣。'
        ],
        scene: '场地狭长，件量适中，以进港件分拣为主的快递网点或分拣点位不太多的电商中心。',
        img: require("@/assets/img/Lineartechnicalparameters.png"),
        Image: require("@/assets/img/Linearbenefits.png"),
        photos: [
            require("@/assets/img/straight1.png"),
            require("@/assets/img/straight2.png"),
        ]
    },
    {
        id: 3,
        name: '摆臂式分拣机',
        src: require("@/assets/img/Lineararmsortingmachine.png"),
        describe: [
            '是一款用于分拣的设备。被分拣的物品放置在钢带式或链板式输送机上，当到达分拣口时，摇臂转动，物品沿摇臂杆斜面滑到指定的目的地。'
        ],
        advantage: [
            '分拣效率较高(双线理论效率1万票/小时)；',
            '可将包裹直接运至出库格口，省略集包和搬运过程，大小货兼容，双线采用双向自动供包台供货，无需粗分；',
            '错分率较低 < 0.05%；',
            '投资极低；'
        ],
        scene: '场地狭长，件量适中，以进港件分拣为主的快递网点或分拣点位不太多的电商中心。',
        Image: require("@/assets/img/Swingarmbenefits.png"),
        photos: [
            require("@/assets/img/arm1.png"),
            require("@/assets/img/arm2.png"),
        ]
    },
    {
        id: 4,
        name: '窄带式交叉带分拣机',
        src: require("@/assets/img/Narrobandcrossbeltsortingmachine.png"),
        describe: [
            '窄带分拣机是直线分拣机变体，小车节距缩小至150mm-200mm，小车长度延长至1米，呈条带状，故称为窄带分拣机。',
            '常配合托盘、 此设备占地面积小，格口规划的灵活性强，常配合托盘、电动叉车一起使用，适用于票件量少、中大件包裹为主的网点或中转场地使用。'
        ],
        advantage: [
            '分拣效率较高(单机理论效率1万票/小时)；',
            '可将包裹直接运至出库格口，省略集包和搬运过程，大小货兼容，可采用六面扫描系统，不需要人工翻面；',
            '错分率低<0.01%；',
            '特别适合进港大小件分拣。'
        ],
        scene: '场地狭长，件量适中，以进港件分拣为主的快递网点或分拣点位不太多的电商中心。',
        img: require("@/assets/img/Narrowbandtechnicalparameters.png"),
        Image: require("@/assets/img/Narrowbandbenefits.png"),
        photos: [
            require("@/assets/img/narrowband1.png"),
            require("@/assets/img/narrowband2.png"),
        ]
        
    },
    {
        id: 5,
        name: '常规小件&扁平件立体分拣机（播种墙）',
        src: require("@/assets/img/Flatthree-dimensionalsortingmachine.png"),
        describe: [
            '播种墙包括播种架以及开设在播种架上的多个物料格口，物料格口用于存放分拣后的货物，且物料格口在播种架上可以呈阵列排布。',
            '在物流分拣时，货物通常按订单任务进行分类，并且按订单任务将货物放置到播种墙的储物格口中，最后对储物格口中的货物按订单进行打包出库。'
        ],
        advantage: [
            '自动化程度高，提升工作效率；',
            '成本低，降低运营成本；',
            '提高周转率，提升准确率；',
            '维护简单，可拓展性强。'
        ],
        scene: '常用于大型仓储中心、电商中心和物流中心，适用于多品订单分拣，尤其在电商大促时能快速处理订单，实现高效发货。',
        img: require("@/assets/img/canshu.png"),
        Image: require("@/assets/img/cesuan.png"),
        photos: [
            require("@/assets/img/Sowing1.png"),
            require("@/assets/img/Sowing2.png"),
        ]
    },
    {
        id: 6,
        name: '系统软件',
        src: require("@/assets/img/xitong.png"),
        describe: [
            '使用分布式控制系统架构，极简操作模式，方便用户操控。',
            '提供操作数据统计功能，直观的图表显示，便于生产管理和调度。',
            '可以根据用户要求提供云端接口，定制微信小程序，方便远程查看生产状态。'
        ],
        photos: [
            require("@/assets/img/xitong1.png"),
            require("@/assets/img/xitong2.png"),
        ]
    }
]